import dayjs, { type Dayjs } from 'dayjs';
import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';

const TodayContext = createContext<Dayjs>(dayjs());

export default function CurrentDateProvider({ children }: { children: ReactNode }) {
  const [currentDay, setCurrentDay] = useState<Dayjs>(dayjs());

  useEffect(() => {
    const i = setInterval(() => setCurrentDay(dayjs().startOf('day')), 60000);
    return () => clearInterval(i);
  }, []);

  return <TodayContext value={currentDay}>{children}</TodayContext>;
}

export function useCurrentDay() {
  return useContext(TodayContext);
}
